// src/components/Layout.js
import React, { useContext } from 'react';
import { Box, CircularProgress, useMediaQuery } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileBottomNav from './MobileBottomNav';
import { AuthContext } from '../contexts/AuthContext.js'; // Make sure path is correct
import { OrgContext } from '../contexts/OrgContext.js'; // Import OrgContext
//
import { LoadingProvider, useLoading } from '../contexts/LoadingContext';

const Layout = () => {
  // theme not currently used
  const { isAuthenticated, loading } = useContext(AuthContext);
  const { orgId } = useContext(OrgContext);
  const location = useLocation();
  const currentPath = location.pathname;
  // const navigate = useNavigate();
  const { isLoading } = useLoading(); // Move hook to top level
  const isMobile = useMediaQuery('(max-width:600px)');

  const showSidebar = isAuthenticated && 
    currentPath !== '/auth' && 
    currentPath !== '/list-orgs';

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <LoadingProvider>
      <Box sx={{ position: 'relative', display: 'flex', minHeight: '100vh' }}>
        {/* Global subtle gradient accents */}
    <Box sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
          <Box sx={{
            position: 'absolute',
            top: '-10%',
            right: '-8%',
            width: { xs: 200, sm: 320 },
            height: { xs: 200, sm: 320 },
            borderRadius: '50%',
      background: 'radial-gradient(closest-side, rgba(56,189,248,0.14), rgba(56,189,248,0) 70%)',
      filter: 'blur(18px) saturate(130%)',
          }} />
          <Box sx={{
            position: 'absolute',
            bottom: '-12%',
            left: '-6%',
            width: { xs: 220, sm: 360 },
            height: { xs: 220, sm: 360 },
            borderRadius: '50%',
      background: 'radial-gradient(closest-side, rgba(99,102,241,0.12), rgba(99,102,241,0) 70%)',
      filter: 'blur(20px) saturate(130%)',
          }} />
        </Box>
        {currentPath !== '/auth' && <Header />}
        {/* Hide sidebar on mobile to free space */}
        {showSidebar && !isMobile && <Sidebar orgId={orgId} />}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            mt: currentPath !== '/auth' ? '64px' : 0,
            ml: showSidebar && !isMobile ? { sm: '240px', xs: '60px' } : 0,
            transition: 'margin-left 0.3s',
            height: isMobile ? 'calc(100vh - 64px - 56px)' : 'calc(100vh - 64px)',
            overflowY: 'auto',
            overflowX: 'hidden',
            boxSizing: 'border-box',
            width: showSidebar && !isMobile
              ? { sm: 'calc(100% - 240px)', xs: 'calc(100% - 60px)' }
              : '100%',
            position: 'relative',
            zIndex: 1,
          }}
        >
          {isLoading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
              <CircularProgress />
            </Box>
          )}
          <Outlet />
        </Box>
        {/* Render bottom nav on mobile */}
        {isAuthenticated && currentPath !== '/auth' && currentPath !== '/list-orgs' && isMobile && (
          <MobileBottomNav orgId={orgId} />
        )}
      </Box>
    </LoadingProvider>
  );
};

export default Layout;
